import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { GetListTypeColumn } from "../services/form";



const useListTypeColumn = () => {

    // States
    const [listTypeColumn, setListTypeColumn] = useState<IGroupKey[]>([]);
    const [loadingTypesColumn, setLoadingTypesColumn] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGeTypeColumn();
    }, [])

    // Handles
    const handleGeTypeColumn = () => {
        setLoadingTypesColumn(true);
        tryCatch(() => {
            GetListTypeColumn()
                .then((response) => {
                    setListTypeColumn(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingTypesColumn(false));
        })
    }

    return {
        listTypeColumn,
        loadingTypesColumn
    }
}


export default useListTypeColumn;